"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userAdminPlatformBulkSoftDelete = exports.userAdminPlatformBulkRestore = exports.userAdminPlatformBulkResponseSuccess = exports.userAdminPlatformBulkResponseError = exports.userAdminPlatformBulkReset = exports.userAdminPlatformBulkHardDelete = exports.userAdminPlatformBulkDeactivate = exports.userAdminPlatformBulkActivate = void 0;
var _userAdminPlatformBulk = require("./userAdminPlatformBulk.constant");
// common success
var userAdminPlatformBulkResponseSuccess = function userAdminPlatformBulkResponseSuccess(actionType, data) {
  return {
    type: _userAdminPlatformBulk.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.userAdminPlatformBulkResponseSuccess = userAdminPlatformBulkResponseSuccess;
var userAdminPlatformBulkResponseError = function userAdminPlatformBulkResponseError(actionType, error) {
  return {
    type: _userAdminPlatformBulk.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Bulk Hard delete platform apdmin user
 * @param payload
 * @returns api response
 * @description this function used for bulk hard delete platform admin user.
 */
exports.userAdminPlatformBulkResponseError = userAdminPlatformBulkResponseError;
var userAdminPlatformBulkHardDelete = function userAdminPlatformBulkHardDelete(data) {
  return {
    type: _userAdminPlatformBulk.actionTypes.HARD_DELETE,
    payload: data
  };
};

/**
 * Platform admin user bulk activate
 * @param payload
 * @returns api response
 * @description this function used for bulk activate of platform admin user.
 */
exports.userAdminPlatformBulkHardDelete = userAdminPlatformBulkHardDelete;
var userAdminPlatformBulkActivate = function userAdminPlatformBulkActivate(data) {
  return {
    type: _userAdminPlatformBulk.actionTypes.ACTIVATE,
    payload: data
  };
};

/**
 * Platform admin user bulk deactivate
 * @param payload
 * @returns api response
 * @description this function used for bulk deactivate of platform admin user.
 */
exports.userAdminPlatformBulkActivate = userAdminPlatformBulkActivate;
var userAdminPlatformBulkDeactivate = function userAdminPlatformBulkDeactivate(data) {
  return {
    type: _userAdminPlatformBulk.actionTypes.DEACTIVATE,
    payload: data
  };
};

/**
 * Reset user admin platform
 * @param payload
 * @returns api response
 * @description this function used to reset user admin platform.
 */
exports.userAdminPlatformBulkDeactivate = userAdminPlatformBulkDeactivate;
var userAdminPlatformBulkReset = function userAdminPlatformBulkReset() {
  return {
    type: _userAdminPlatformBulk.actionTypes.RESET
  };
};

/**
 * Platform admin user bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used for bulk soft delete of platform admin user.
 */
exports.userAdminPlatformBulkReset = userAdminPlatformBulkReset;
var userAdminPlatformBulkSoftDelete = function userAdminPlatformBulkSoftDelete(data) {
  return {
    type: _userAdminPlatformBulk.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * Platform admin user bulk restore
 * @param payload
 * @returns api response
 * @description this function used for bulk restore of platform admin user.
 */
exports.userAdminPlatformBulkSoftDelete = userAdminPlatformBulkSoftDelete;
var userAdminPlatformBulkRestore = function userAdminPlatformBulkRestore(data) {
  return {
    type: _userAdminPlatformBulk.actionTypes.RESTORE,
    payload: data
  };
};
exports.userAdminPlatformBulkRestore = userAdminPlatformBulkRestore;